import { useState } from 'react';
import type * as React from 'react';

import { Styled } from './controlled-input-bar.styles';

interface ControlledInputBarProps {
  name: string;
  placeholder: string;
  onChange?: (name: string, value: string) => void;
}

const ControlledInputBar = ({
  name,
  placeholder,
  onChange,
}: ControlledInputBarProps): JSX.Element => {
  const [value, setValue] = useState<string>('');

  const handleChange: React.FormEventHandler<
    HTMLInputElement | HTMLTextAreaElement
  > = (e) => {
    const inputValue = e.currentTarget.value;
    if (inputValue.length <= 280) {
      setValue(inputValue);
      onChange?.(name, inputValue);
    }
  };

  return (
    <Styled.ControlledInputBar
      placeholder={placeholder}
      value={value}
      multiline={true}
      onChange={handleChange}
    />
  );
};

ControlledInputBar.displayName = 'ControlledInputBar';

export default ControlledInputBar;
